module.exports = "/_next/static/images/banner_icon_toysmarket-c07c8b8223d1b71cde4fae3455000170.svg";